let apiUrl
const apiUrls = {
  production: 'https://not-a-tourist-api.herokuapp.com',
  development: 'http://localhost:4741'
}

if (window.location.hostname === 'localhost') {
  apiUrl = apiUrls.development
} else {
  apiUrl = apiUrls.production
}

export default apiUrl



// WEBPACK FOOTER //
// ./src/apiConfig.js